var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMatchHatProfilePlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 130,
    viewBox: "0 0 130 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 2.5,
    width: 125,
    height: 125,
    rx: 62.5,
    fill: "#F0F1F5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 2.5,
    width: 125,
    height: 125,
    rx: 62.5,
    stroke: "white",
    strokeWidth: 5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.9552 55.6225C87.9548 55.6225 87.9548 55.6223 87.9548 55.6221C87.9552 55.5955 87.9556 55.5689 87.9556 55.5422V50.6077C87.9556 48.1354 85.5254 46.3988 83.1921 47.204L66.2011 53.068C65.4438 53.3293 64.6211 53.3297 63.8636 53.069L46.8021 47.1981C44.4695 46.3954 42.0416 48.1319 42.0416 50.6029V55.6225V58.1431V75.12C42.0416 76.1141 41.2372 76.92 40.245 76.92H38.089C36.4132 76.92 35.0547 78.281 35.0547 79.96C35.0547 81.639 36.4132 83 38.089 83H91.9082C93.5839 83 94.9425 81.639 94.9425 79.96C94.9425 78.281 93.5839 76.92 91.9082 76.92H89.7523C88.7601 76.92 87.9556 76.1141 87.9556 75.12V55.623C87.9556 55.6227 87.9556 55.6225 87.9552 55.6225Z",
    fill: "#A5A5A5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMatchHatProfilePlaceholder);
export default __webpack_public_path__ + "static/media/match-hat-profile-placeholder.2edc105526abaf37f34ea6b72a1b0a7f.svg";
export { ForwardRef as ReactComponent };